export default function authHeader() {
    let token = localStorage.getItem("AUTH");
    if (token) {
        return { Authorization: "Bearer " + token };
    } else {
        return {};
    }
}
